<ng-container *ngIf="importFileResponse && entity !== 'EMPLOYEE'">
  <form [formGroup]="confirmImportForm">
    <ng-container *ngIf="importFileResponse.warnings">
      <ng-container [ngTemplateOutletContext]="{index: 0, count: warningsCount, type: 'warning'}" [ngTemplateOutlet]="errorWarningTemplate"></ng-container>
      <div *ngFor="let row of importFileResponse.warnings"
           [(ngbCollapse)]="collapsedSections[0]"
           class="row">
        <div class="col-12 text-warning">
          {{ 'imports.row' | translate }} {{ 'imports.number' | translate }} {{ row.row }} - {{ row.message | translate }} {{ row.data ? ' - ' + row.data : '' }} - {{ row.action | translate }}.
        </div>
      </div>
    </ng-container>
    
    <ng-container *ngIf="importFileResponse.errors">
      <ng-container [ngTemplateOutletContext]="{index: 1, count: errorsCount, type: 'error'}" [ngTemplateOutlet]="errorWarningTemplate"></ng-container>
      <div *ngFor="let row of importFileResponse.errors"
           [(ngbCollapse)]="collapsedSections[1]"
           class="row">
        <div class="col-12 text-danger">
          {{ 'imports.row' | translate }} {{ 'imports.number' | translate }} {{ row.row }} - {{ row.message | translate }} {{ row.data ? ' - ' + row.data : '' }} -  {{ row.action | translate }}.
        </div>
      </div>
    </ng-container>
    
    <div *ngIf="importFileResponse.stats" class="mt-3">
      <div *ngIf="importFileResponse.stats.total">
        <span class="mr-3">{{ 'imports.total' | translate }}: <strong>{{ importFileResponse.stats.total }}</strong></span>
        <span class="mr-3">{{ 'imports.created' | translate }}: <strong>{{ importFileResponse.stats.created }}</strong></span>
        <span class="mr-3">{{ 'imports.updated' | translate }}: <strong>{{ importFileResponse.stats.updated }}</strong></span>
        <span class="mr-3">{{ 'imports.ignored' | translate }}: <strong>{{ importFileResponse.stats.ignored }}</strong></span>
      </div>
    </div>
    <div *ngIf="entity === 'REAL_WAGE' && confirmImportForm?.controls?.['rates']" [formGroupName]="'rates'" class="mt-3">
      <div *ngFor="let row of importFileResponse.required_rates; let index = index" class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="control-label">{{ row.label }}</label>
            <input class="form-control" formControlName="{{row.label}}" id="{{index}}" name="{{index}}" type="number">
          </div>
        </div>
        <div class="col-12 text-right">
          <small class="text-muted"> {{ row.help }} </small>
        </div>
      </div>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="importFileResponseEmployee && entity === 'EMPLOYEE'">
  <ng-container *ngIf="importFileResponseEmployee.warnings">
    <ng-container [ngTemplateOutletContext]="{index: 2, count: warningsCount, type: 'warning'}" [ngTemplateOutlet]="errorWarningTemplate"></ng-container>
    <div *ngFor="let row of importFileResponseEmployee.warnings | keyvalue"
         [(ngbCollapse)]="collapsedSections[2]"
         class="row">
      <div *ngFor="let employeeRow of row.value" class="col-12 text-warning">
        {{ 'imports.row' | translate }} {{ 'imports.number' | translate }} {{ employeeRow.row }}. - {{ employeeRow.message | translate }} {{ row.data ? ' - ' + row.data : '' }} - {{ employeeRow.group | translate }} - {{ employeeRow.action | translate }}.
      </div>
    </div>
  </ng-container>
  
  <ng-container *ngIf="importFileResponseEmployee.errors">
    <ng-container [ngTemplateOutletContext]="{index: 3, count: errorsCount, type: 'error'}" [ngTemplateOutlet]="errorWarningTemplate"></ng-container>
    <div *ngFor="let row of importFileResponseEmployee.errors | keyvalue"
         [(ngbCollapse)]="collapsedSections[3]"
         class="row">
      <div *ngFor="let employeeRow of row.value" class="col-12 text-danger">
        {{ 'imports.row' | translate }} {{ 'imports.number' | translate }} {{ employeeRow.row }}. - {{ employeeRow.message | translate }} {{ row.data ? ' - ' + row.data : '' }} - {{ employeeRow.group | translate }} - {{ employeeRow.action | translate }}.
      </div>
    </div>
  </ng-container>
  <div *ngIf="importFileResponseEmployee.stats" class="mt-3">
    <ng-container [ngTemplateOutletContext]="{value: importFileResponseEmployee.stats.total, type: 'total'}" [ngTemplateOutlet]="employeeImportStatsRow"></ng-container>
    <ng-container [ngTemplateOutletContext]="{value: importFileResponseEmployee.stats.saved, type: 'to_be_saved'}" [ngTemplateOutlet]="employeeImportStatsRow"></ng-container>
    <ng-container [ngTemplateOutletContext]="{value: importFileResponseEmployee.stats.ignored, type: 'ignored'}" [ngTemplateOutlet]="employeeImportStatsRow"></ng-container>
  </div>
</ng-container>

<ng-template #errorWarningTemplate let-count='count' let-index='index' let-type='type'>
  <div
      (click)="collapsedSections[index] = !collapsedSections[index]"
      [attr.aria-expanded]="!collapsedSections[index]"
      [ngClass]="{'text-danger': type === 'error', 'text-warning': type === 'warning'}"
      class="row m-0 py-2 cursor-pointer font-weight-bold"
  >
    <i
        *ngIf="collapsedSections[index]"
        class="mdi mdi-menu-right mr-1 mdi-24px d-inline-block menu-arrow-collapse"
    ></i>
    <i
        *ngIf="!collapsedSections[index]"
        class="mdi mdi-menu-down mr-1 mdi-24px d-inline-block menu-arrow-collapse"
    ></i>
    {{
          ('global.' + type + 's') | translate
    }}
    {{ "(" + count + ")" }}
  </div>
</ng-template>

<ng-template #employeeImportStatsRow let-type=type let-value="value">
  <div *ngIf="value">
    <div class="card-header">{{ ('imports.' + type) | translate }}</div>
    <div class="card-body">
      <span class="mr-3">{{ 'imports.employees_import.employees' | translate }}: <strong>{{ value.employees }}</strong></span>
      <span class="mr-3">{{ 'imports.employees_import.employee_personal_data' | translate }}: <strong>{{ value.personal_data }}</strong></span>
      <span class="mr-3">{{ 'imports.employees_import.position_history' | translate }}: <strong>{{ value.position_history }}</strong></span>
      <span class="mr-3">{{ 'imports.employees_import.other_addresses' | translate }}: <strong>{{ value.other_addresses }}</strong></span>
      <span class="mr-3">{{ 'imports.employees_import.salary_history' | translate }}: <strong>{{ value.salary_history }}</strong></span>
      <span class="mr-3">{{ 'imports.employees_import.bonus_history' | translate }}: <strong>{{ value.bonus_history }}</strong></span>
    </div>
  </div>
</ng-template>
